import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../actions/e-loketLayoutActions";
import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";
import { showToastrSuccess, showToastrError } from "../util/toastr.js";
import internalApi from "../api/internal/internalApi";

import RelativeLink from "./common/RelativeLink";
import Section from "./common/Section";
import Fieldset from "./common/Fieldset";
import Row from "./common/Row";
import Col from "./common/Col";
import Button from "./common/Button";
import TextInput from "./common/TextInput";
import * as types from "../constants/ComponentConstants";
import { AccountTypes, Environments } from "../constants/DomainConstants";

import { MultiToggle } from './common/MultiToggle';
import OKToggle from './common/OKToggle';
import redirector from "../util/redirector";
require("./common/MultiToggle.css");

class TestPage extends Component {
	constructor(props, context) {
		super(props, context, true);

		this.state = {
			federatieId: null,
			organisationId: null,
			tochtId: null,
			lusId: null,
			gemeenteId: null,
			groupSize: 2
		};
	}

	componentWillMount() {
		if (this.props.environments === Environments.PRD) {
			redirector.goTo("/");
		}
	}

	componentDidMount() {
		this.props.loadLayout();
	}

	nukeCache() {
		const listByUrl = prependRoot("/global/nukecache", getApiRoot());
		axios.get(listByUrl, {
			headers: {
				'accept': 'application/json'
			}
		}).then(response => {
			if (response.statusText === "OK") {
				showToastrSuccess("Cache Cleared");
			} else {
				showToastrError("FAILED. OH NO... :(");
			}
		});
	}

	onChange = (event) => {
		const property = event.target.name;
		const value = event.target.value;

		let newState = Object.assign({}, this.state);
		newState[property] = value;

		this.setState(
			newState
		);
	};


	handleOnChangeGemeente(i) {
		const rolrol = this.context.state;
		return function (event) {
			rolrol.setState(
				{
					valueMultiSwitch: event
				}
			);
		};
	}



	onToggle(selectedItem) {
		this.context.setState(
			{
				valueMultiSwitch: selectedItem
			}
		);
	}

	onGroupSizeSelect = (obj) => {
		let state = this.state;
		state[obj.target.name] = obj.target.value;

		this.setState(state);
	};

	onClickPublishTochtToUIV = () => {
		return internalApi.publishTochtToUIV(this.state.tochtId)
			.then(response => {
				if (response.data === 0) {
					showToastrSuccess("de vlag 'publiceren op UIV' staat af...");
				}
				else if (response.data === 1) {
					showToastrSuccess("de tocht op Uit in Vlaanderen wordt aangemaakt");
				}
				else if (response.data === 2) {
					showToastrSuccess("de tocht op Uit in Vlaanderen wordt aangepast");
				}
				else if (response.data === 3) {
					showToastrSuccess("de tocht op Uit in Vlaanderen wordt geschrapt");
				}
			});
	};

	render() {

		const federatieId = this.state.federatieId;
		const organisationId = this.state.organisationId;
		const tochtId = this.state.tochtId;
		const lusId = this.state.lusId;
		const gemeenteId = this.state.gemeenteId;
		const onChange = this.onChange;
		const divStyle = { background: "#f6f6f6", borderRadius: "5px", margin: "10px" };

		const groupOptions = [
			{
				displayName: ' ',
				selectedDisplayName: 'NOK',
				value: 1,
				optionClass: 'red'
			},
			{
				displayName: ' ',
				selectedDisplayName: 'Neutral',
				value: 0,
				optionClass: 'gray'
			},
			{
				displayName: ' ',
				selectedDisplayName: 'OK',
				value: 2,
				optionClass: 'green'
			},
		];

		const groupOptions2 = [
			{
				displayName: ' ',
				selectedDisplayName: 'NOK',
				value: 1,
				optionClass: 'red'
			},
			{
				displayName: ' ',
				selectedDisplayName: 'Neutral',
				value: 0,
				optionClass: 'gray'
			},
			{
				displayName: ' ',
				selectedDisplayName: 'OK',
				value: 2,
				optionClass: 'green'
			},
			{
				displayName: ' ',
				selectedDisplayName: 'OK',
				value: 3,
				optionClass: 'orange'
			},
		];

		const groupOptionsDisplay = [
			{
				displayName: 'NOK',
				selectedDisplayName: 'NOK',
				value: 0,
				optionClass: 'red'
			},
			{
				displayName: 'default',
				selectedDisplayName: 'Neutral',
				value: 1,
				optionClass: 'gray'
			},
			{
				displayName: 'OK',
				selectedDisplayName: 'OK',
				value: 2,
				optionClass: 'green'
			},
		];

		const groupOptionsColor = [
			{
				displayName: 'NOK',
				selectedDisplayName: 'NOK',
				value: 0,
				optionClass: 'red'
			},
			{
				displayName: 'default',
				selectedDisplayName: 'Neutral',
				value: 1,
				optionClass: 'red'
			},
			{
				displayName: 'OK',
				selectedDisplayName: 'OK',
				value: 2,
				optionClass: 'red'
			},
		];

		const { groupSize, multiToggleMain, multiToggleMain1, multiToggleMain2, multiToggleMain3, multiToggleMain4, uitlegEvent, AANGELEGD, KOEIEN, REGEN, DOUCHE, DOUCHE2, DOUCHE3, VOORUIT } = this.state;

		return (
			<Fragment>
				<Section title={"Start to test"} color={types.COLOR_BLUE}>
					<Row>
						<Col>
							<Fieldset>
								<TextInput
									name={"federatieId"}
									label={"Federatie Id"}
									value={federatieId}
									onChange={onChange}
									size={12}
								/>
								<br />
								<TextInput
									name={"organisationId"}
									label={"Organisatie Id"}
									value={organisationId}
									onChange={onChange}
									size={12}
								/>
								<br />
								<TextInput
									name={"tochtId"}
									label={"Tocht Id"}
									value={tochtId}
									onChange={onChange}
									size={12}
								/>
								<br />
								<TextInput
									name={"lusId"}
									label={"Lus Id"}
									value={lusId}
									onChange={onChange}
									size={12}
								/>
								<br />
								<TextInput
									name={"gemeenteId"}
									label={"Gemeente Id"}
									value={gemeenteId}
									onChange={onChange}
									size={12}
								/>
							</Fieldset>
						</Col>
						<Col>
							<Fieldset>
								<Button
									text={"Clear Cache"}
									onClick={this.nukeCache}>
								</Button>
							</Fieldset>
						</Col>
					</Row>
					<Row>
						<Col>
							<div style={divStyle}>
								<Fieldset title="Startpagina's">
									<RelativeLink to={"/e-loket"} title="Start pagina" className="c-button c-button--small">
										Start Organisator
                                </RelativeLink>
									<br />
									<br />
									<RelativeLink to={"/e-loket/gemeenteStart"} title="Startpagina gemeente" className="c-button c-button--small">
										Start Gemeente
                                </RelativeLink>
									<br />
									<br />
									<RelativeLink to={"/e-loket/federatieStart"} title="Startpagina federatie" className="c-button c-button--small">
										Start Federatie
                                </RelativeLink>
									<br />
									<br />
								</Fieldset>
							</div>
						</Col>
						<Col>
							<div style={divStyle}>
								<Fieldset title="Tocht Overzicht">
									<RelativeLink to={"/e-loket/" + organisationId + "/veldtoertochten"} title="Overzicht tochten per organisator" className="c-button c-button--small">
										van een Organisator
                                </RelativeLink>
									<br />
								(of /e-loket/organisatoroverzicht?id=ID_ORGANISATOR)
                                <br />
									<RelativeLink to={"/e-loket/" + gemeenteId + "/gemeente/veldtoertochten"} title="Overzicht tochten per gemeente" className="c-button c-button--small">
										van een Gemeente
                                </RelativeLink>
									<br />
								(of /e-loket/gemeenteoverzicht?id=ID_GEMEENTE)
                                <br />
									<RelativeLink to={"/e-loket/" + federatieId + "/federatieOverzicht"} title="Overzicht tochten per federatie" className="c-button c-button--small">
										van een Federatie
                                </RelativeLink>
									<br />
								(of /e-loket/federatieoverzicht?id=ID_FEDERATIE)
                                <br />
									<br />
									<RelativeLink to={"/e-loket/" + federatieId + "/kalenderGoedkeuren"} title="Kalender goedkeuren voor federatie" className="c-button c-button--small">
										Kalender Tochten goedkeuren voor Federatie
                                </RelativeLink>
									<br />
									<br />
								</Fieldset>
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div style={divStyle}>
								<Fieldset title="Tocht">
									<RelativeLink to={"/e-loket/veldtoertocht/nieuw"} title="Aanmaken tocht - nieuwe organisator" className="c-button c-button--small">
										Nieuwe Tocht - Nieuwe Organisator
                                </RelativeLink>
									<br />
									<br />
									<Button
										text={"Publish naar UIV"}
										onClick={this.onClickPublishTochtToUIV}
										className="c-button c-button--small">
									</Button>
									<br />
									<br />
								</Fieldset>
							</div>
						</Col>
						<Col>
							<div style={divStyle}>
								<Fieldset title="Wijzigen van een Tocht">
									<RelativeLink to={"/e-loket/" + AccountTypes.ORGANISATOR + "/" + organisationId + "/organisator/" + tochtId} title="Wijzig Organisator" className="c-button c-button--small">
										Wijzig Organisator
                                </RelativeLink>
									<br />
									<br />
									<RelativeLink to={"/e-loket/" + AccountTypes.ORGANISATOR + "/" + organisationId + "/lussen/" + tochtId + "/" + lusId} title="Wijzig Lus" className="c-button c-button--small">
										Wijzig lus
                                </RelativeLink>
									<br />
									<br />
									<RelativeLink to={"/e-loket/" + AccountTypes.ORGANISATOR + "/" + organisationId + "/goedkeuringen/" + tochtId} title="Wijzig goedkeuringen" className="c-button c-button--small">
										Wijzig goedkeuringen
                                </RelativeLink>
									<br />
									<br />
								</Fieldset>
							</div>
						</Col>
					</Row>
					<Row>
						<Col>
							<div style={divStyle}>
								<Fieldset title="Zoekmotor">
									<RelativeLink to={"/zoekmotor/overzicht"} title="Overzicht" className="c-button c-button--small">
										Overzicht
                                </RelativeLink>
									<br />
									<br />
								</Fieldset>
							</div>
						</Col>
					</Row>

					<Row>
						https://github.com/willhlaw/react-multi-toggle-extra
                </Row>
					<Fieldset title="Startplaats van de veldtoertocht">
						<Row>
							<Col size={4}>
								<label>Is de startplaats mooi aangelegd?</label>
							</Col>
							<Col size={2}>
								<MultiToggle
									options={groupOptions}
									selectedOption={AANGELEGD}
									onSelectOption={this.onGroupSizeSelect}
									name="AANGELEGD"
								/>
							</Col>
						</Row>
						<Row>
							<Col size={4}>
								<label>Geef uitleg over het event</label>
							</Col>
							<Col size={8}>
								<TextInput
									name={"uitlegEvent"}
									value={uitlegEvent}
									onChange={this.onGroupSizeSelect}
								/>
							</Col>
						</Row>
						<Row>
							<Col size={4}>
								<label>Lopen er koeien in de wei?</label>
							</Col>
							<Col size={2}>
								<MultiToggle
									options={groupOptions}
									selectedOption={KOEIEN}
									onSelectOption={this.onGroupSizeSelect}
									name="KOEIEN"
								/>
							</Col>
						</Row>
						<Row>
							<Col size={4}>
								<label>Regent het veel?</label>
							</Col>
							<Col size={2}>
								<MultiToggle
									options={groupOptions}
									selectedOption={REGEN}
									onSelectOption={this.onGroupSizeSelect}
									name="REGEN"
								/>
							</Col>
							<Col size={4}>
								<label>Regent het veel?</label>
							</Col>
						</Row>
						<Row>
							<Col size={4}>
								<label>Kunnen we een doucheke nemen?</label>
							</Col>
							<Col size={2}>
								<MultiToggle
									options={groupOptions}
									selectedOption={DOUCHE}
									onSelectOption={this.onGroupSizeSelect}
									name="DOUCHE"
								/>
							</Col>
							<Col size={4}>
								<label>Kunnen we een doucheke nemen?</label>
							</Col>
						</Row>
						<Row>
							<Col size={4}>
								<label>Kunnen we een doucheke nemen?</label>
							</Col>
							<Col size={2}>
								<MultiToggle
									options={groupOptions2}
									selectedOption={DOUCHE2}
									onSelectOption={this.onGroupSizeSelect}
									name="DOUCHE2"
								/>
							</Col>
						</Row>
						<Row>
							<Col size={4}>
								<label>Nu gaat het vooruit?</label>
							</Col>
							<Col size={2}>
								<OKToggle
									kleurbalk={false}
									value={VOORUIT}
									onChange={this.onGroupSizeSelect}
									name="VOORUIT"
								/>
							</Col>
						</Row>

						<Row>
							<Col size={4}>
								<label>Kunnen we een doucheke nemen?</label>
							</Col>
							<Col size={4}>
								<MultiToggle
									options={groupOptions2}
									selectedOption={DOUCHE3}
									onSelectOption={this.onGroupSizeSelect}
									name="DOUCHE3"
								/>
							</Col>
						</Row>
						<Row>
							<Col size={4}>
								<label>Nu gaat het vooruit?</label>
							</Col>
							<Col size={4}>
								<OKToggle
									disabled
									size={12}
									value={VOORUIT}
									onChange={this.onGroupSizeSelect}
									name="VOORUIT"
								/>
							</Col>
						</Row>
					</Fieldset>
				</Section >
			</Fragment>);
	}
}

TestPage.propTypes = {
	loadLayout: PropTypes.func,
	environments: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	return {
		maxMapFeaturesToLoad: state.settings.maxMapFeaturesToLoad,
		osmBaseLayerUrl: state.settings.osmBaseLayerUrl
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadTestPageLayout, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(TestPage);
